import { defineMessages } from 'react-intl';

export default defineMessages({
  twitter: {
    id: 'social-share.twitter',
    defaultMessage: 'Watch "{title}" on {siteUrl}',
  },
  pinterest: {
    id: 'social-share.pinterest',
    defaultMessage: '{title} - {description}',
  },
  tumblr: {
    id: 'social-share.tumblr',
    defaultMessage: '{title} - {siteUrl}',
  },
});



// WEBPACK FOOTER //
// ./src/widget/player-widget/components/social-share/translations.js